import * as v from 'valibot';
import { IdSchema, EmailSchema } from './common.js';
export const AdminInviteRoleSchema = v.picklist(['owner', 'admin']);
export const CreateRoomInviteSchema = v.object({
    roomId: IdSchema,
    groupId: v.optional(IdSchema),
    email: EmailSchema
});
export const CreateAdminInviteSchema = v.object({
    email: EmailSchema,
    targetRole: AdminInviteRoleSchema
});
/** Organization role invite — owners only. */
export const CreateStaffInviteSchema = v.object({
    email: EmailSchema,
    targetRole: AdminInviteRoleSchema
});
export const CreateInviteSchema = v.pipe(v.object({
    email: EmailSchema,
    roomId: v.optional(IdSchema),
    groupId: v.optional(IdSchema),
    targetRole: v.optional(AdminInviteRoleSchema)
}), v.forward(v.check((input) => (input.targetRole != null && input.roomId == null) ||
    (input.targetRole == null && input.roomId != null), 'Provide exactly one of: roomId (invite to room) or targetRole (invite as owner/admin).'), ['targetRole']));
export const RedeemInviteSchema = v.object({
    token: v.pipe(v.string(), v.minLength(1))
});
//# sourceMappingURL=invite.js.map